import Security from './apis/Security'

export default {
  login(user, pass, rememberMe, callback) {
    delete this.context
    Security.login(user, pass, rememberMe)
      .then(() => this.isLoggedIn().then(callback))
      .catch((e) => {
        const resp = e.response
        callback(false, resp || e.message)
      })
  },

  refreshContext() {
    return Security.userInfo().then((resp) => {
      this.context = resp.data
    })
  },

  logout(callback) {
    delete this.context
    Security.logout()
      .then(() => callback(true))
      .catch(() => callback(false))
  },

  isLoggedIn() {
    return new Promise((resolve, reject) => {
      if (this.context) {
        resolve(!!this.context.authStatus)
      } else {
        Security.userInfo()
          .then((resp) => {
            this.context = resp.data
            resolve(!!this.context.authStatus)
          })
          .catch(reject)
      }
    });
  },
  getAuthStatus() {
    return this.context && this.context.authStatus
  },

  getUserContext() {
    return this.context
  },

  getUsername() {
    const authStatus = this.getAuthStatus()
    return authStatus && authStatus.USERNAME
  },
  isAdmin() {
    return this.hasRole('ROLE_ADMIN')
  },
  hasRole(role) {
    const authStatus = this.getAuthStatus()
    return authStatus && authStatus.ROLES.indexOf(role) !== -1
  }
}



// WEBPACK FOOTER //
// ./src/service/AuthService.js